import React from 'react';
import Stack from '@mui/material/Stack';
import IconButton from '@mui/material/IconButton';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
interface SocialProps {}

const SocialList: React.FC<SocialProps> = () => {
  return (
    <>
      <Stack spacing={0} direction="row" sx={{ paddingLeft: 0.25 }}>
        <IconButton edge="start" href="https://www.facebook.com/TCNGiftCards" target="_blank" size="large">
          <FacebookIcon />
        </IconButton>
        <IconButton href="https://www.linkedin.com/company/tcn-the-card-network/" target="_blank" size="large">
          <LinkedInIcon />
        </IconButton>
        <IconButton href="https://www.instagram.com/thecardnetwork/" target="_blank" size="large">
          <InstagramIcon />
        </IconButton>
      </Stack>
    </>
  );
};

export default SocialList;
